export default __webpack_public_path__ + "static/media/mode-51.246ad7f9.svg";